module.exports = __webpack_public_path__ + "media/images/emblems/Founex-coat_of_arms-98b73badadba12ba44c8fd282f39dbe9.svg";